import React from 'react';

const Check = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;

// colour cycle matches the design: green, pink, blue, green, pink, blue
const PILLS = [
    { t: 'Growth SMEs', c: 'green' },
    { t: 'Fractional CFOs', c: 'pink' },
    { t: 'Investors & VCs', c: 'blue' },
    { t: 'Angel networks', c: 'green' },
    { t: 'PE firms', c: 'pink' },
    { t: 'Accountants', c: 'blue' },
];

// corner photos — positions + sizes taken verbatim from the design
const PEOPLE = [
    { cls: 'p1', img: require('../../../../images/landing-pages/partner/cfo.png'), alt: 'Growth SME founder' },
    { cls: 'p2', img: require('../../../../images/landing-pages/partner/company.png'), alt: 'Investor' },
    { cls: 'p3', img: require('../../../../images/landing-pages/partner/angel.png'), alt: 'Fractional CFO' },
    { cls: 'p4', img: require('../../../../images/landing-pages/partner/accountant.png'), alt: 'Advisor' },
];

const PartnerReachSection = () => (
    <section className="lp-partner-reach">
        <div className="lp-partner-reach-inner">
            <div className="lp-partner-reach-copy">
                <h2 data-lp-reveal>Who can you reach?</h2>
                <p data-lp-reveal data-lp-delay="60">Growth SMEs, fractional CFOs, and investors — every one of them mid-transaction, already looking for a solution like yours.</p>
            </div>
            <div className="lp-partner-reach-art" data-lp-reveal data-lp-delay="120">
                <div className="lp-partner-reach-pills">
                    {PILLS.map((p, i) => <span className={`pill pill--${p.c}`} key={i}><i><Check /></i>{p.t}</span>)}
                </div>
                {PEOPLE.map((p) => (
                    <span className={`lp-partner-reach-photo ${p.cls}`} key={p.cls}><img src={p.img} alt={p.alt} /></span>
                ))}
            </div>
        </div>
    </section>
);

export default PartnerReachSection;
